module.exports = __webpack_public_path__ + "static/img/ex02.d0f1671b.png";